// extracted by mini-css-extract-plugin
module.exports = {"verifiedOld":"verified-badge_verifiedOld__mErH8","verifiedBlue":"verified-badge_verifiedBlue__fbSq6","verifiedGovernment":"verified-badge_verifiedGovernment__BHT3z"};